export const levels = [
  {
    ap: 0,
    level: 0,
    canEdit: false,
    canDelete: false,
    canReward: false,
    canPinPlaylists: false,
    canEditPlaylists: false,
    canEditRewardLevel: false,
    managementLevel: 0
  },
  {
    ap: 0,
    level: 1,
    canEdit: false,
    canDelete: false,
    canReward: false,
    canPinPlaylists: false,
    canEditPlaylists: false,
    canEditRewardLevel: false,
    managementLevel: 0
  },
  // moderator level
  {
    ap: 150,
    level: 2,
    canEdit: false,
    canDelete: true,
    canReward: false,
    canPinPlaylists: false,
    canEditPlaylists: false,
    canEditRewardLevel: false,
    managementLevel: 0
  },
  {
    ap: 300,
    level: 3,
    canEdit: false,
    canDelete: true,
    canReward: true,
    canPinPlaylists: false,
    canEditPlaylists: false,
    canEditRewardLevel: false,
    managementLevel: 0
  },
  {
    ap: 500,
    level: 4,
    canEdit: false,
    canDelete: true,
    canReward: true,
    canPinPlaylists: false,
    canEditPlaylists: true,
    canEditRewardLevel: false,
    managementLevel: 0
  },
  // teacher level
  {
    ap: 1000,
    level: 5,
    canEdit: false,
    canDelete: true,
    canReward: true,
    canPinPlaylists: false,
    canEditPlaylists: true,
    canEditRewardLevel: true,
    managementLevel: 1
  },
  {
    ap: 1300,
    level: 6,
    canEdit: false,
    canDelete: true,
    canReward: true,
    canPinPlaylists: false,
    canEditPlaylists: true,
    canEditRewardLevel: true,
    managementLevel: 2
  },
  // headteacher level
  {
    ap: 1500,
    level: 7,
    canEdit: true,
    canDelete: true,
    canReward: true,
    canPinPlaylists: false,
    canEditPlaylists: true,
    canEditRewardLevel: true,
    managementLevel: 2
  },
  {
    ap: 1800,
    level: 8,
    canEdit: true,
    canDelete: true,
    canReward: true,
    canPinPlaylists: false,
    canEditPlaylists: true,
    canEditRewardLevel: true,
    managementLevel: 2
  },
  // headmaster level
  {
    ap: 3000,
    level: 9,
    canEdit: true,
    canDelete: true,
    canReward: true,
    canPinPlaylists: true,
    canEditPlaylists: true,
    canEditRewardLevel: true,
    managementLevel: 2
  },
  {
    ap: 3300,
    level: 10,
    canEdit: true,
    canDelete: true,
    canReward: true,
    canPinPlaylists: true,
    canEditPlaylists: true,
    canEditRewardLevel: true,
    managementLevel: 2
  }
];
